var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftarrow2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 8.96997C2.25 8.57215 2.40804 8.19062 2.68934 7.90931C2.97064 7.62801 3.35218 7.46997 3.75 7.46997H22.5C22.8978 7.46997 23.2794 7.62801 23.5607 7.90931C23.842 8.19062 24 8.57215 24 8.96997C24 9.3678 23.842 9.74933 23.5607 10.0306C23.2794 10.3119 22.8978 10.47 22.5 10.47H3.75C3.35218 10.47 2.97064 10.3119 2.68934 10.0306C2.40804 9.74933 2.25 9.3678 2.25 8.96997Z",
    fill: "url(#paint0_linear_3144_256)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.97009C8.49561e-05 8.5723 0.158176 8.19083 0.4395 7.90959L7.1895 1.15959C7.32787 1.01633 7.49339 0.902054 7.67639 0.82344C7.8594 0.744827 8.05623 0.703448 8.2554 0.701717C8.45457 0.699986 8.65209 0.737939 8.83643 0.81336C9.02078 0.888782 9.18825 1.00016 9.32909 1.141C9.46993 1.28184 9.58131 1.44932 9.65673 1.63366C9.73215 1.81801 9.77011 2.01553 9.76838 2.21469C9.76665 2.41386 9.72527 2.61069 9.64665 2.7937C9.56804 2.97671 9.45376 3.14222 9.3105 3.28059L3.621 8.97009L9.3105 14.6596C9.58374 14.9425 9.73493 15.3214 9.73151 15.7147C9.72809 16.108 9.57034 16.4842 9.29223 16.7623C9.01412 17.0404 8.6379 17.1982 8.2446 17.2016C7.85131 17.205 7.4724 17.0538 7.1895 16.7806L0.4395 10.0306C0.158176 9.74935 8.49561e-05 9.36788 0 8.97009Z",
    fill: "url(#paint1_linear_3144_256)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3144_256",
    x1: 2.25,
    y1: 8.96997,
    x2: 24,
    y2: 8.96997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3144_256",
    x1: 0,
    y1: 8.95166,
    x2: 9.76843,
    y2: 8.95166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow2);
export default __webpack_public_path__ + "static/media/leftarrow2.8f5bf8d6525f86e6a7456439c34dcc4c.svg";
export { ForwardRef as ReactComponent };